<script>
import DatePicker from "@/components/input/DatePicker/DatePicker";

export default {
  name: "DateRangePicker2",
  mixins: [DatePicker],
  props: {
    startDate: [String, Date],
    endDate: [String, Date],
  },
  data: () => ({
    singleDatePicker: false
  }),
  watch: {
    "dateRange": {
      handler(newValue) {
        if (!this.formatOnFirst) return;
        if (newValue.startDate === null) {
          this.dateRange.startDate = null;
          this.dateRange.endDate = null;
          return;
        }
        if (newValue.startDate && newValue.startDate !== this.$dayJs(newValue.startDate).format("YYYY-MM-DD")) {
          this.onChange("update:startDate", newValue.startDate);
        }
        if (newValue.endDate && newValue.endDate !== this.$dayJs(newValue.endDate).format("YYYY-MM-DD")) {
          this.onChange("update:endDate", newValue.endDate);
        }

        this.$emit("change", newValue)
      },
      immediate: true
    }
  },
  computed: {
    dateRange: {
      get() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
        }
      },
      set(newValue) {
        this.onChange("update:startDate", newValue.startDate);
        this.onChange("update:endDate", newValue.endDate);
      }
    }
  },
}
</script>
